(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const bar = document.getElementById('announcementBarInner');

  if (bar) {
    // Duplicate content to create seamless loop
    bar.innerHTML += bar.innerHTML;

    let scrollSpeed = 0.5;

    // Continuous scrolling loop
    const scroll = () => {
      bar.scrollLeft += scrollSpeed;

      // Reset position when halfway through duplicated content
      if (bar.scrollLeft >= bar.scrollWidth / 2) {
        bar.scrollLeft = 0;
      }

      requestAnimationFrame(scroll);
    };

    scroll();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jale-layout"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
